export default __webpack_public_path__ + "static/media/consolidate.07225611.webp";